import type {
    ApplicationInsights as ApplicationInsightsType,
    IEventTelemetry,
    IExceptionTelemetry,
    ITraceTelemetry,
    SeverityLevel
} from '@microsoft/applicationinsights-web';

// In case of any issues, check if version of Application Insights injected by DXP is compatible
// with the types imported from @microsoft/applicationinsights-web.

export { SeverityLevel } from '@microsoft/applicationinsights-web';
declare let appInsights: ApplicationInsightsType;

export class ApplicationInsights {
    public static TrackException(exception: Error | string, properties?: IExceptionTelemetry['properties']) {
        if (typeof appInsights === 'undefined' || !appInsights) {
            return;
        }

        if (typeof exception === 'string') {
            appInsights.trackException({ exception: new Error(exception), properties });
        } else {
            appInsights.trackException({ exception, properties });
        }
    }

    public static TrackTrace(severityLevel: SeverityLevel, message: string, properties?: ITraceTelemetry['properties']) {
        if (typeof appInsights === 'undefined' || !appInsights) {
            return;
        }

        appInsights.trackTrace({ message, severityLevel, properties });
    }

    public static TrackEvent(name: string, properties?: IEventTelemetry['properties']) {
        if (typeof appInsights === 'undefined' || !appInsights) {
            return;
        }

        appInsights.trackEvent({ name, properties });
    }
}
